"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateListPropertyEnquiryDto = instanceOfCreateListPropertyEnquiryDto;
exports.CreateListPropertyEnquiryDtoFromJSON = CreateListPropertyEnquiryDtoFromJSON;
exports.CreateListPropertyEnquiryDtoFromJSONTyped = CreateListPropertyEnquiryDtoFromJSONTyped;
exports.CreateListPropertyEnquiryDtoToJSON = CreateListPropertyEnquiryDtoToJSON;
exports.CreateListPropertyEnquiryDtoToJSONTyped = CreateListPropertyEnquiryDtoToJSONTyped;
/**
 * Check if a given object implements the CreateListPropertyEnquiryDto interface.
 */
function instanceOfCreateListPropertyEnquiryDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function CreateListPropertyEnquiryDtoFromJSON(json) {
    return CreateListPropertyEnquiryDtoFromJSONTyped(json, false);
}
function CreateListPropertyEnquiryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
function CreateListPropertyEnquiryDtoToJSON(json) {
    return CreateListPropertyEnquiryDtoToJSONTyped(json, false);
}
function CreateListPropertyEnquiryDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
    };
}
